import { formReducer, modelReducer } from 'react-redux-form'
import { combineReducers } from 'redux'

import { handleRest } from '../../js/h2Api'
import { FORM_SUBMIT } from '../actions/hubspot'

export const genericFormState = {}

const reducerRequest = (state = handleRest(), action) => {
  switch (action.type) {
    case FORM_SUBMIT:
      return {
        ...handleRest(action)
      }
    default:
      return state
  }
}
const reducers = combineReducers({
  genericForm: modelReducer('hubspot.genericForm', genericFormState),
  forms: formReducer('hubspot', {
    genericForm: genericFormState
  }),
  formRequest: reducerRequest
})

export default reducers
